import { type ComputedRef } from 'vue';

import * as API from '../requests';
import useLiveMarketDepthQueryFactory from './useLiveMarketDepthQueryFactory';
import { SYMBOL_QUERY_KEYS } from '../constants';

type useLiveBuyMarketDepthQueryConfigs = {
  isin: ComputedRef<string | null>;
  exchangeCode: ComputedRef<string | null>;
};

export default function useLiveBuyMarketDepthQuery({
  isin,
  exchangeCode,
}: useLiveBuyMarketDepthQueryConfigs) {
  const {
    execute: getBuyMarketDepth,
    result: buyMarketDepth,
    isLoadingMarketDepth: isLoadingBuyMarketDepth,
    isRevalidatingMarketDepth: isRevalidatingBuyMarketDepth,
    isErrorMarketDepth: isErrorBuyMarketDepth,
    marketDepthStatus: buyMarketDepthStatus,
  } = useLiveMarketDepthQueryFactory({
    immediate: true,
    type: 1,
    isin,
    key: SYMBOL_QUERY_KEYS.buyMarketDepth(isin),
    sorter: (a, b) => b.price - a.price,
    fetcher: () =>
      API.getBuyMarketDepth({
        isin: isin.value,
        exchangeCode: exchangeCode.value,
      }),
  });

  return {
    buyMarketDepth,
    getBuyMarketDepth,
    isLoadingBuyMarketDepth,
    isRevalidatingBuyMarketDepth,
    isErrorBuyMarketDepth,
    buyMarketDepthStatus,
  };
}
